<template>
    <div class="mb main bg-black col">
            <div id="footer-main-row" class="row">
                <div class="footer-col col" style="display: none">
                  <img
            id="olecio-logo"
            class="mr-2 mt-05 top-row-logo"
            src="https://oleciocdn.fra1.cdn.digitaloceanspaces.com/prod/cvtheque/olecio_logo_white.png"
            style="margin-top: 0.82rem"
          />
                    <h4 class="col-title text-start txt-white">La mission d’Olecio</h4>
                    <p class="img-txt-content text-start txt-white fontGrot">Face aux besoins immenses de facilitation de la rencontre entre l’offre et la demande, <span style="text-decoration: underline">Olecio</span> développe une approche complète pour faciliter la concrétisation des projets professionnels et les besoins en ressources humaines des organisations.</p>
                </div>
                <div id="mid-footer-col" class="footer-col footer-col-pt col">
                  <p class="img-txt-content text-start txt-white fontGrot" style="margin-bottom: 1rem">
                    Ce site est édité par Olecio pour le compte de Constructys et de ses partenaires ; il complète les services de <a href="https://www.vigiebtp-idf.fr/" style="color: white" target="_blank"><span style="text-decoration: underline">Vigie BTP IDF</span></a> pour faciliter la mise en relation entre les entreprises et les candidats en recherche d'emplois. </p>
                    <!--
                      <p class="img-txt-content text-start txt-white fontGrot" style="margin-bottom: 1rem">Ce site est édité par Olecio pour le compte de Constructys et de ses partenaires en complément du Portail <a href="https://www.vigiebtp-idf.fr/" style="color: white"><span style="text-decoration: underline">Vigie BTP</span></a></p>
                      <h4 class="col-title text-start txt-white">A propos de Vigie BTP</h4>
                    -->
                    <p class="img-txt-content text-start txt-white fontGrot"><a href="https://www.vigiebtp-idf.fr/" style="color: white" target="_blank"><span style="text-decoration: underline">Vigie BTP IDF</span></a> est un site dédié à l’emploi et à la formation dans le BTP en Ile-de-France. Il a été conçu à destination des entreprises et des prescripteurs pour favoriser le rapprochement entre l'offre et la demande d'emplois.</p>
                </div>
                <div class="footer-col footer-col-pt col" style="display: none">
                    <h4 class="col-title text-start txt-white">Suivez-nous</h4>
                    <div class="icons-row row">
                        <img class="footer-img" src="https://oleciocdn.fra1.cdn.digitaloceanspaces.com/prod/cvtheque/facebook-icon.png"/>
                        <img id="footer-img-mid" class="footer-img" src="https://oleciocdn.fra1.cdn.digitaloceanspaces.com/prod/cvtheque/twitter-icon.png"/>
                        <img class="footer-img" src="https://oleciocdn.fra1.cdn.digitaloceanspaces.com/prod/cvtheque/insta-icon.png"/>
                    </div>
                    <h4 id="other-website" class="text-start txt-white">Nos autres sites</h4>
                    <a class="footer-links fontGrot text-start txt-white">Les métiers avec Olecio</a>
                    <a class="footer-links fontGrot text-start txt-white">L’application OMG</a>
                    <a class="footer-links fontGrot text-start txt-white">Merci Bobby</a>
                    <a class="footer-links fontGrot text-start txt-white">Le média Olecio</a>
                    <a class="footer-links fontGrot text-start txt-white">“Taffer comment ?”, l’émission</a>
                </div>
            </div>
            <div class="bottom-links-row row txt-white">
                <a>Mentions légales et politique de confidentialité</a>
                <span class="mx"> | </span>
                <a>Conditions Générales d’utilisation</a>
                <span class="mx"> | </span>
                <a>Contactez-nous</a>
            </div>
        </div>
  </template>
  
  <script>
  export default {
    name: "PageFooter",
  };
  </script>
  
  <style src="../pages/landing-page.scss" lang="scss"></style>
  <style scoped>
  #footer-main-row {
    /* margin-top: 10rem; */
    justify-content: center;
  }
  #olecio-logo {
    max-width: 8rem;
    margin-bottom: 1rem;
  }
  #mid-footer-col {
    margin-left: 4.5rem;
    margin-right: 4.5rem;
  }
.footer-col {
    max-width: 45rem;
  }
  .col-title {
    margin-bottom: 0rem;
  }
  #other-website {
    margin-bottom: 0.25rem;
  }
  .col-title,
  #other-website {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .icons-row {
    margin-top: 1rem;
  }
  .footer-links {
    text-decoration: underline;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .footer-img {
    max-width: 15%;
    height: auto;
  }
  #footer-img-mid {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
  .text-start {
    text-align: start;
  }
  .mx {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
  .bottom-links-row {
    justify-content: center;
    margin-top: 6rem;
    margin-bottom: 2rem;
  }
  .bottom-links-row a {
    text-decoration: underline;
  }
  @media screen and (min-width: 800px) {
    .footer-col-pt{
      /* padding-top:5.5rem; */
      padding-top:8rem;
    }
  }
  @media screen and (max-width: 460px) {
    .footer-col {
    max-width: 15rem;
  }
    .row,
    .col{
      justify-content: center;
      align-items: center;
    }
    #footer-main-row{
      margin-top: 2rem;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .text-start{
      text-align: center;
    }
  }
  </style>